import { Navigate, useLocation } from 'react-router-dom';
import {
  selectAuthLoading,
  selectAuthenticated,
  selectDemoOrgDetails,
  selectOfficeDetails,
  selectRegistrationStatus,
  selectUserDetails,
} from 'modules/Authentication/slice/selectors';

import { Loader } from 'modules/common/Loaders/Loader';
import { StyleConstants } from 'styles/StyleConstants';
import { selectInstallHeaderVisible } from 'modules/common/slice/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useCommonFunctionSlice } from 'modules/common/slice';
import { useOrganisationUiSlice } from 'styles/OrganisationUi/slice';
import { useThemeSlice } from 'styles/theme/slice';
import { selectOrganisationUiDetails } from 'styles/OrganisationUi/slice/selectors';
import { AddNewTheme } from 'styles/theme/themes';

export default function PrivateRoutesLoader({
  PrivateRouteEncloser,
  routeProps,
  ...props
}) {
  const { actions: commonActions } = useCommonFunctionSlice();

  const dispatch = useDispatch();
  const { actions: orgUiActions } = useOrganisationUiSlice();
  const { actions: themeActions } = useThemeSlice();
  const orgUiDetails = useSelector(selectOrganisationUiDetails);

  const isAuthLoading = useSelector(selectAuthLoading);
  const isAuthenticated = useSelector(selectAuthenticated);
  const isRegistered = useSelector(selectRegistrationStatus);
  // const isUserVerified = useSelector(selectVerificationStatus);
  const { userDetails } = useSelector(selectUserDetails);

  const showInstallHeader = useSelector(selectInstallHeaderVisible);

  const demoOrgDetails = useSelector(selectDemoOrgDetails);
  const { officeId } = useSelector(selectOfficeDetails);

  useEffect(() => {
    if (demoOrgDetails) {
      dispatch(
        commonActions.toggleIsDemoDataActive({
          isDemoDataActive: !!demoOrgDetails,
        }),
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [demoOrgDetails]);

  useEffect(() => {
    officeId &&
      dispatch(
        orgUiActions.fetchOrgUiDetailsStart({
          organisation_office_id: officeId,
        }),
      );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [officeId]);

  const changeTheme = themeKey => {
    dispatch(themeActions.changeTheme(themeKey));
  };

  useEffect(() => {
    if (orgUiDetails) {
      AddNewTheme(orgUiDetails, `${Date.now()}theme`, changeTheme);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgUiDetails]);

  const prevRoute = useLocation();

  // if (userDetails?.status === 'inactive') {
  //   return <Navigate replace to="/inactive-user" />;
  // }

  return isAuthLoading ? (
    <Loader />
  ) : isAuthenticated ? (
    isRegistered ? (
      // && isUserVerified
      <PrivateRouteEncloser
        {...routeProps}
        height={
          showInstallHeader
            ? `calc(100vh - ${StyleConstants.INSTALL_HEADER_HEIGHT})`
            : '100vh'
        }
      >
        {props.children}
      </PrivateRouteEncloser>
    ) : (
      <Navigate replace to="/registration" />
    )
  ) : (
    <Navigate replace to="/signin" state={{ prevRoute }} />
  );
}
